import { Injectable } from "@angular/core";
import { HelperService } from "../shared/services/helper.service";
import { environment } from "../../environments/environment";
import { HttpService } from "../shared/services/http.service";
import {
    GiftCardOrderSalesModel, GiftCardVirtualsModel,
    GiftCardClientsModel, GiftCardContactModel, GiftCardTypesModel,
    GiftCardGroupModel, GiftCardModel
} from "../models/gifcardVirtual.model";

@Injectable()
export class GifcardFisicaService {
    private PARAMETER_ENDPOINT: string = '/giftCardVirtual';
    private BASE_URL: string = HelperService.buildRequestURL(environment.RipleyGiftCardVirtualApiEndPoint);
    private REQUEST_URL: string = `${this.BASE_URL}${this.PARAMETER_ENDPOINT}`;
    private URL: string;
    public TYPE_ORDER_SALES_FISICA = "F";

    constructor(private httpService: HttpService) { }
   
    public GetGiftCardOrderSalesFisica() {
        this.URL = `${this.REQUEST_URL}/getOrderSalesFisica`;
        return this.httpService.get<GiftCardOrderSalesModel[]>(this.URL);
    }    

    public GetOrderSalesFisicaByStatus(params) {
        this.URL = `${this.REQUEST_URL}/getOrderSalesFisicaByStatus`;
        return this.httpService.post<GiftCardOrderSalesModel[]>(this.URL, params);
    }

    public GetOrderSalesFisicaByStatusAndUser(params) {
        this.URL = `${this.REQUEST_URL}/getOrderSalesFisicaByStatusAndUser`;
        return this.httpService.post<GiftCardOrderSalesModel[]>(this.URL, params);
    }

    public CreateOrderSalesFisica(orderSales) {
        this.URL = `${this.REQUEST_URL}/createOrderSalesFisica`;
        return this.httpService.post<any>(this.URL, orderSales);
    }

    public UpdateOrderSalesFisicaStatus(params) {
        this.URL = `${this.REQUEST_URL}/updateOrderSalesFisicaStatus`;
        return this.httpService.put<any>(this.URL, params);
    }

    public UpdateOrderSalesFisicaFacturacion(params) {
        this.URL = `${this.REQUEST_URL}/updateOrderSalesFisicaFacturacion`;
        return this.httpService.put<any>(this.URL, params);
    }
}